import { theme as antdTheme } from 'antd';
import type { ThemeConfig } from 'antd';
import { ADMIN_COLORS as C, ADMIN_COLORS_DARK as D, ADMIN_FONT } from './tokens';

// Theme antd cho khu admin (ConfigProvider bọc DefaultLayout). Kế thừa locale của ConfigProvider gốc.
// Sáng khớp thiết kế; tối dùng darkAlgorithm + nền/viền theo token dark.
export const getAdminTheme = (isDark: boolean): ThemeConfig => {
  const shared = {
    colorPrimary: C.primary,
    colorInfo: C.primary,
    colorLink: C.primary,
    colorLinkHover: C.primaryHover,
    colorSuccess: C.successFill,
    colorError: C.danger,
    colorWarning: C.warning,
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 6,
    borderRadiusXS: 6,
    controlHeight: 40,
    controlHeightSM: 32,
    controlHeightLG: 48,
    fontFamily: ADMIN_FONT,
    fontSize: 14,
    controlOutline: 'rgba(79,166,223,0.45)',
  };

  const button = {
    borderRadius: 9999,
    borderRadiusLG: 9999,
    borderRadiusSM: 9999,
    fontWeight: 600,
    paddingInline: 20,
    paddingInlineSM: 14,
    primaryShadow: 'none',
    defaultShadow: 'none',
    dangerShadow: 'none',
  };

  if (isDark) {
    return {
      algorithm: antdTheme.darkAlgorithm,
      token: {
        ...shared,
        colorBgLayout: D.bg,
        colorBgContainer: D.surface,
        colorBgElevated: D.surface,
        colorBorder: D.lineInput,
        colorBorderSecondary: D.line,
        colorText: D.text,
        colorTextHeading: D.heading,
        colorTextSecondary: D.muted,
        colorTextDescription: D.muted,
      },
      components: {
        Button: button,
        Table: {
          headerBg: D.surface2,
          headerColor: D.muted,
          headerSplitColor: 'transparent',
          borderColor: D.line,
          rowHoverBg: D.surface2,
          cellPaddingBlock: 14,
          cellPaddingInline: 16,
          headerBorderRadius: 0,
        },
        Input: { colorBorder: D.lineInput },
        InputNumber: { colorBorder: D.lineInput },
        Select: { colorBorder: D.lineInput },
        DatePicker: { colorBorder: D.lineInput },
        Modal: { borderRadiusLG: 16, contentBg: D.surface, headerBg: D.surface },
        Tag: { borderRadiusSM: 9999 },
        Pagination: { itemActiveBg: 'rgba(79,166,223,0.16)', borderRadius: 9999 },
        Tabs: { inkBarColor: C.primary, itemSelectedColor: D.onSoft, titleFontSize: 14 },
      },
    };
  }

  return {
    algorithm: antdTheme.defaultAlgorithm,
    token: {
      ...shared,
      colorBgLayout: C.bg,
      colorBgContainer: C.surface,
      colorBorder: C.lineStrong,
      colorBorderSecondary: C.line,
      colorText: C.text,
      colorTextHeading: C.heading,
      colorTextSecondary: C.muted,
      colorTextDescription: C.muted,
      colorTextPlaceholder: C.subtle,
      colorFillAlter: C.bg,
      boxShadow: '0 12px 32px rgba(18,28,42,0.14), 0 2px 6px rgba(18,28,42,0.06)',
      boxShadowSecondary: '0 12px 32px rgba(18,28,42,0.14), 0 2px 6px rgba(18,28,42,0.06)',
    },
    components: {
      Button: { ...button, defaultBorderColor: C.lineStrong, defaultColor: C.onFill },
      Table: {
        headerBg: C.bg,
        headerColor: C.muted,
        headerSplitColor: 'transparent',
        borderColor: C.line,
        rowHoverBg: C.bg,
        cellPaddingBlock: 14,
        cellPaddingInline: 16,
        headerBorderRadius: 0,
      },
      Input: { colorBorder: C.lineInput, hoverBorderColor: C.primary, activeBorderColor: C.primary },
      InputNumber: { colorBorder: C.lineInput, hoverBorderColor: C.primary, activeBorderColor: C.primary },
      Select: { colorBorder: C.lineInput },
      DatePicker: { colorBorder: C.lineInput, hoverBorderColor: C.primary, activeBorderColor: C.primary },
      Modal: { borderRadiusLG: 16, titleFontSize: 18, titleColor: C.heading },
      Tag: { borderRadiusSM: 9999, defaultBg: C.fill, defaultColor: C.onFill },
      Pagination: { itemActiveBg: C.soft, itemSize: 32, borderRadius: 9999 },
      Tabs: { inkBarColor: C.primary, itemSelectedColor: C.onSoft, itemColor: C.nav, titleFontSize: 14 },
      Card: { borderRadiusLG: 16 },
    },
  };
};

export default getAdminTheme;
